import { useEffect } from "react";

const useClearLocalStorageOnClose = () => {
  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem("token");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
};

export default useClearLocalStorageOnClose;
